import axios from 'axios';
import {
  MDBAlert,
  MDBBadge,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBInput,
  MDBInputGroup,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBRow
} from 'mdb-react-ui-kit';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router-dom';
import { CartContext } from '../context/CartProvider';
import { CategoryContext } from '../context/CategoryContext';
import { GeographyContext } from '../context/GeographyProvider';
import { MiscContext } from '../context/MiscProvider';
import { NavbarContext } from '../context/NavProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
import AddNewEntity from '../entity/AddNewEntity';
import GalleryComponent from '../products/GalleryComponent';
import ItemView from '../products/ItemView';
import { fetchMainPageData } from '../utils/Common';

const Shop = ({ pricingCategoryId }) => {

  const domainIdFromLocalStorage = localStorage.getItem('DOMAIN');
  const {showAlert, setShowAlert, alertMessage} = useContext(MiscContext);
  const {ipAddress,location,currencies,country} = useContext(GeographyContext);
  const {setCategoryId} = useContext(CategoryContext);
  const {tokenLoaded} = useContext(UserProfileContext);
  const { setCartCount, cartId, qty, setQty, setCartId, addedEntities, setAddedEntities, weight, setWeight } = useContext(CartContext);
  const { setIsPricing, isPricing,pageData,setPageData ,setBusiness} = useContext(NavbarContext);
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;

  const getUnitByCountry = useCallback((countryObj) => {
    const countryName = countryObj?.country?.toLowerCase();
    console.log("Searching for:", countryName);

    const currency = currencies.find(currency => currency?.country?.toLowerCase() === countryName);
    console.log("Found currency:", currency);

    return currency ? currency.unit : null;
  }, [currencies]);

  const [isCarouselOpen, setIsCarouselOpen] = useState(false);
  const [units, setUnits] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const sectionRef = useRef(null);
  const [position, setPosition] = useState('top-center');
  const [alertForeCartItemAdded, setAlertForeCartItemAdded] = useState(false);

  useEffect(() => {
    if (!pageData) {
      fetchMainPageData(setPageData, setIsPricing,pageData,setBusiness);
    }
  }, []);

  useEffect(() => {
   // setIsPricing(window.location.host.includes("expenses") || window.location.host.includes("x-trk"));
    const unit = getUnitByCountry({ country });
    setUnits(unit);
    if (cartId) {
      console.log("Cart ID has been updated:", cartId);
    }
  }, [cartId, country, getUnitByCountry, setIsPricing]);

  const { categoryId } = useParams();
  const defaultCategoryId = pricingCategoryId;
  const selectedCategoryId = categoryId || defaultCategoryId;

  const [categoryData, setCategoryData] = useState([]);

  const createCart = async (item, index) => {
    const itemWeight = (weight && weight[item.id]) || 1;
    const itemQty = (qty && qty[item.id]) || 1;
    const itemMetrics = item?.metrics || 'lbs';

    try {
      const cart = {
        ldapTitle: item.name,
        entityId: item.id,
        entityIdToQty: {
          [item.id]: {
            qty: itemQty,
            weight: itemWeight,
            metrics: itemMetrics
          }
        }
      };

      const localCartId = (item.cartId && tokenLoaded) ? item.cartId : cartId || localStorage.getItem('CART-ID');
      setCartId(item.cartId);
      let url;
      if (tokenLoaded) {
        url = (cartId || localCartId) ? `${baseUrl}/cart/${localCartId}` : `${baseUrl}/cart`;
      } else {
        url = (cartId || localCartId) ? `${baseUrl}/cart/anonymous/${localCartId}` : `${baseUrl}/cart/anonymous`;
      }

      let response;
      let latLngQuery = "";
      if (location) {
        latLngQuery = `?latitude=${location.latitude}&longitude=${location.longitude}`;
      } else {
        latLngQuery = `?ipAddress=${ipAddress}`;
      }
      url = url + latLngQuery;

      if (localCartId) {
        response = await axios.put(url, cart);
      } else {
        response = await axios.post(url, cart);
        const newCartId = response.data.id;
        setCartId(newCartId);
        localStorage.setItem('CART-ID', newCartId);
      }

      const newAddedEntities = response?.data?.entities ? new Set(response?.data?.entities?.map(entity => entity.id)) : new Set(Object.keys(response?.data?.entityIdToQty || {}));
      setAddedEntities(newAddedEntities);
      const count = response.data?.totalQty || response.data?.qty || 0;

      setCartCount(count);
      setAlertForeCartItemAdded(true);
    } catch (error) {
      localStorage.setItem('CART-ID', '');
      console.error('Error creating or updating cart:', error);
    }
  };

  const fetchItems = useCallback(async (domainIdf) => {
    setIsSubmitting(true);
    setCategoryId(selectedCategoryId);
    try {
      let url = tokenLoaded ? `${baseUrl}/entities/selling/domainId/${domainIdFromLocalStorage}` : `${baseUrl}/entities/byhost`;
      let latLngQuery = "";
      if (location) {
        console.log(`Latitude: ${location.latitude}, Longitude: ${location.longitude}`);
        latLngQuery = `?latitude=${location.latitude}&longitude=${location.longitude}`;
      } else {
        latLngQuery = `?ipAddress=${ipAddress}`;
        if (!ipAddress) {
          return;
        }
      }
      url = url + latLngQuery;
  
      const response = await axios.get(url);
      const items = response.data;
  
      const categoryGroups = getCategoryGroups(items);
      const groupedItemsData = Object.entries(categoryGroups)?.map(([category, items]) => ({ category, items }));
  
      setCategoryData(groupedItemsData);
  
      const cartUrl = tokenLoaded ? `${baseUrl}/cart` : (cartId && tokenLoaded) ? `${baseUrl}/cart/${cartId}` : cartId && `${baseUrl}/cart/anonymous/${cartId}`;
  
      if (cartUrl) {
        const cartResponse = await axios.get(cartUrl);
        const cart = cartResponse.data;
  
        if (cart && cart.entityIdToQty) {
          const count = cart.totalQty
          const newAddedEntities = new Set(Object.keys(cart.entityIdToQty || {}));
          
          setAddedEntities(newAddedEntities);
          setCartId(cart.id);
          setCartCount(count);
  
         
        }
      }
    } catch (error) {
      console.error("Error in fetchItems: ", error);
    }
    setIsSubmitting(false);
  }, [cartId, tokenLoaded]);
  
  // Helper function to group items by category
  function getCategoryGroups(items) {
    return items.reduce((groups, item) => {
      if (item.images && item.images.length > 0) {
        item.image = item.images[0];
      }
      if (item.categoryIdToName) {
        // Choose the first category as the primary category for the item
        const primaryCategoryId = Object.keys(item.categoryIdToName)[0];
        const primaryCategoryName = item.categoryIdToName[primaryCategoryId];
  
        const categoryGroup = groups[primaryCategoryName] || [];
        categoryGroup.push(item);
        groups[primaryCategoryName] = categoryGroup;
      }
      return groups;
    }, {});
  }


  function getCategoryGroups(items) {
    return items.reduce((groups, item) => {
      console.log("Item in reduce: ", item);
      if (item.images && item.images.length > 0) {
        item.image = item.images[0];
      }
      if (item.categoryIdToName) {
        const primaryCategoryId = Object.keys(item.categoryIdToName)[0];
        const primaryCategoryName = item.categoryIdToName[primaryCategoryId];

        const categoryGroup = groups[primaryCategoryName] || [];
        categoryGroup.push(item);
        groups[primaryCategoryName] = categoryGroup;
      }
      return groups;
    }, {});
  }

  useEffect(() => {
    if (!isSubmitting) {
      fetchItems();
    }
  }, []);

  const [viewItem, setViewItem] = useState(null);
  const [addNewModalOpen, setAddNewModalOpen] = useState(false);

  const toggleAddNewModal = () => {
    setAddNewModalOpen(!addNewModalOpen);
  };

  const [viewModalOpen, setViewModalOpen] = useState(false);
  const toggleViewModal = () => {
    setViewModalOpen(!viewModalOpen);
  };
  const handleViewModalClose = () => {
    toggleViewModal();
  };

  const handleView = (item) => {
    setViewItem(item);
    toggleViewModal();
  };

  const [lightbox, setLightbox] = useState({ show: false, image: null });

  const scrollToSection = () => {
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };



  return (
    <section className="mb-2 position-relative grainy-gradient-intro justify-content-center text-center" >
      <MDBAlert open={showAlert}
        color='warning'
        autohide
        delay={5000}
        onClose={() => setShowAlert(false)}
      >
        {alertMessage}<MDBBtn className='ms-3' color='none' tag='a' onClick={() => setShowAlert(false)}>close</MDBBtn>
      </MDBAlert>

      {isPricing &&
        <div style={{ minWidth: '10rem', textAlign: 'center' }}>
          <Link to='/' >
            <p><MDBIcon fas icon="hand-point-left" />{tokenLoaded ? 'upgrade or downgrade' : 'Go Back to Subscribe'}</p>
          </Link>
        </div>
      }
      <MDBRow>
        <MDBCardTitle className='justify-content-center text-center '>
          <div className="d-flex align-items-center justify-content-center text-center">
            <img
              src="https://opengrit.com/images/effortlessSales1"
              alt="Shop"
              style={{ height: '50px' }}
              className="me-2"
            />  <h2 className="display-7 fw-bold text-uppercase text-primary mb-0">Shop </h2>
          </div>

          {!isPricing && (
    <p>
      <figure className='mb-0 small'>
        {units === 'lbs' && (
          <figcaption className='blockquote-footer mt-3 small text-primary'>
            All items are priced per <strong className='text-uppercase'>{units?.replace('s', "")}</strong>
          </figcaption>
        )}
      </figure>
    </p>
  )}

        </MDBCardTitle>
      </MDBRow>

      <h4 className="fw-bold text-uppercase mt-5 text-black mb-0" style={{ letterSpacing: "5px" }}>{pricingCategoryId || selectedCategoryId}</h4>
      <MDBContainer className="mb-2 grainy-gradient-intro justify-content-center text-center">
        <MDBRow className='d-flex row-cols-1 mt-2 row-cols-1 row-cols-md-3 g-4  justify-content-center'>
          {
            categoryData.find(category => category.category === selectedCategoryId)?.items?.map((item, index) => (
              displayEntities(index, item)
            ))
          }
        </MDBRow>
      </MDBContainer>

      <ItemView key={`ItemView-${viewModalOpen}`} item={viewItem} show={viewModalOpen} handleViewModalClose={handleViewModalClose} createCart={createCart} weight={weight} setWeight={setWeight} qty={qty} setQty={setQty} />
      <AddNewEntity show={addNewModalOpen} handleAddModalClose={toggleAddNewModal} setAddNewModalOpen={setAddNewModalOpen} setAlertVisible={setShowAlert}/>
    </section>
  );

  function displayEntities(index, item) {
    return <MDBCol key={index}   className='d-flex'>
      <MDBCard className='justify-content-center align-items-center ' style={{ maxWidth: '540px' }}>
        <div className='position-relative text-black rounded-5 image-wrapper d-flex justify-content-center align-items-center'>
          {(item && item?.imageIds && item?.imageIds[0]) &&
            <MDBBtn onClick={() => handleView(item)} className='position-relative text-black rounded image-wrapper d-flex' color='light' >
              <MDBCardImage position='top'
                src={(item && item.imageIds && item?.imageIds[0])}
                alt='...'
              />
            </MDBBtn>}

          {lightbox?.show && (
            <MDBModal staticBackdrop={true} closeOnEsc={true}
              animationDirection='right'
              open={lightbox?.show}
              centered={true}
              className="modal-backdrop.show"
            >
              <MDBModalDialog centered={true} size="xl">
                <MDBModalContent centered={true}>
                  <MDBModalBody className='text-center'>
                    <GalleryComponent item={item} />
                  </MDBModalBody>
                  <MDBModalFooter>
                    <MDBBtn color="secondary" onClick={() => setLightbox({ ...lightbox, show: false })}>
                      Close
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>
          )}

          {localStorage.getItem('ROLE') === 'owner' && <span style={{  top: 5, left: 14}}>
            <MDBBadge color='none' light pill className='position-absolute top-0 start-100 translate-middle p-2 '>
              <MDBBtn className='ms-2' tag='a' color='none' floating onClick={() => setAddNewModalOpen(true)} >
                <MDBIcon fas icon="edit" color='black' />
              </MDBBtn>
            </MDBBadge>
          </span>}

          {parseInt(item?.discountedPrice, 10) > 0 &&
            <span className="position-absolute" style={{ top: '8px'}}>
           <MDBBadge color='none' light pill className='top-0 start-100 translate-middle p-2 '>
                <strong className="badge bg-success text-wrap " >
                  Discount {item?.currencySymbol} {(parseInt(item?.originalPrice, 10)) - (parseInt(item?.discountedPrice, 10))}
                </strong>
              </MDBBadge>
            </span>}
        </div>
        <MDBCardBody className='justify-content-center'>
          <MDBCardTitle>
            <div key={index} className='position-relative d-inline-block justify-content-center align-items-center'>
              <span className='d-inline-block text-truncate text-capitalize text-black fw-bold fs-6 ' style={{ maxWidth: 350 }}> {item?.name}  </span>
              <span className="position-absolute" style={{ top: '1px', right: '2px' }}>
                <MDBBadge color='none' className='position-absolute translate-middle top-0 start-100'>
                  <MDBBtn size="sm" color='none' tag='a' onClick={() => {
                    handleView(item);
                  }} style={{ color: '#55acee' }}>
                    <MDBIcon fas icon="info-circle" size='sm' />
                  </MDBBtn>
                </MDBBadge>
              </span>
            </div>
          </MDBCardTitle>

          {ItemMeasurements(weight, index, item, setWeight, qty, setQty, isPricing)}
        </MDBCardBody>
        <MDBRow className="d-grid mx-auto d-flex">
          <MDBCol className='justify-content-center align-items-center d-flex'>
            <MDBBtn className='mb-1' onClick={() => createCart(item, index)}>
              <MDBIcon fas icon={(addedEntities instanceof Set && addedEntities.has(item?.id)) ? "cart-plus" : "shopping-cart"} /> {(addedEntities instanceof Set && addedEntities.has(item?.id)) ? "update" : "add"}
            </MDBBtn>
          </MDBCol>
          <MDBCol className='justify-content-center align-items-center d-flex'>
            <strong className='text-success '><span className={parseInt(item?.discountedPrice, 10) !== 0 && 'text-decoration-line-through'}>{item?.currencySymbol} {item?.originalPrice}</span></strong>
          </MDBCol>
         {parseInt(item?.discountedPrice, 10) !== 0 && <MDBCol className='justify-content-center align-items-center d-flex'>
            <strong className='text-success '><span>{item?.currencySymbol} {item?.discountedPrice}</span></strong>
          </MDBCol>}
        </MDBRow>
      </MDBCard>
    </MDBCol>
  }

  function ItemMeasurements(weight, index, item, setWeight, qty, setQty, isPricing) {
    return <MDBRow>
      {isPricing ? <MDBCol className='d-flex align-items-center'>
        <MDBInput label='Qty' name='Qty' id='typeNumber' type='number' min="0" value={qty[item.id] || (qty && qty[item.id]) || (item?.qty || 1)} onChange={e => { setQty(prev => ({ ...prev, [item.id]: parseInt(e.target.value, 10) })) }} />
        <div className="d-flex flex-column align-items-center">
          <MDBBtn color="link" size="sm" onClick={() => { setQty(prev => ({ ...prev, [item.id]: (prev[item.id] || item?.qty || 1) + 1 })) }}>+</MDBBtn>
          <MDBBtn color="link" size="sm" onClick={() => { setQty(prev => ({ ...prev, [item.id]: Math.max((prev[item.id] || item?.qty || 1) - 1, 1) })) }}>-</MDBBtn>
        </div>
      </MDBCol>
        : <MDBInputGroup>
          <MDBCol xs='6' sm='6' md='6' className='d-flex align-items-center'>
            <MDBInput label='Qty' name='Qty' id={`qty-${item.id}`} type='number' min="0" value={qty[item.id] || item.qty || 1} onChange={e => setQty(prev => ({ ...prev, [item.id]: parseInt(e.target.value, 10) }))} />
            <div className="d-flex flex-column align-items-center">
              <MDBBtn color="link" size="sm" onClick={() => setQty(prev => ({ ...prev, [item.id]: (prev[item.id] || item.qty || 1) + 1 }))}>+</MDBBtn>
              <MDBBtn color="link" size="sm" onClick={() => setQty(prev => ({ ...prev, [item.id]: Math.max((prev[item.id] || item.qty || 1) - 0, 0) }))}>-</MDBBtn>
            </div>
          </MDBCol>
          <MDBCol xs='6' sm='6' md='6' className='me-1 d-flex align-items-center justify-content-center'>
            <MDBInput label='Wt' name='Weight' id={`weight-${item.id}`} type='number' min="0.25" step={0.25} value={weight[item.id] || item.weight || 1} onChange={e => setWeight(prev => ({ ...prev, [item.id]: parseFloat(e.target.value) }))} />
            <div className="d-flex flex-column align-items-center">
              <MDBBtn className='rounded' color="link" size="sm" onClick={() => setWeight(prev => ({ ...prev, [item.id]: Math.max((prev[item.id] || item.weight || 1) + 0.25, 0.25) }))}>+</MDBBtn>
              <MDBBtn color="link" size="sm" onClick={() => setWeight(prev => ({ ...prev, [item.id]: Math.max((prev[item.id] || item.weight || 1) - 0.25, 0.25) }))}>-</MDBBtn>
            </div>
          </MDBCol>
        </MDBInputGroup>}
    </MDBRow>
  }
}

Shop.propTypes = {
  pricingCategoryId: PropTypes.string,
};
export default Shop;
